var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../app';
import { Component } from '../../lib/dom';
import './DebugScreen.less';
var DebugScreen = /** @class */ (function (_super) {
    __extends(DebugScreen, _super);
    function DebugScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'DebugScreen';
        _this.counter = 0;
        _this.onClickCloseBtn = function () {
            _this.toggle(false);
            App.sounds.click();
        };
        _this.onClickBtn1 = function () {
            if (_this.props.onClickBtn1)
                _this.props.onClickBtn1();
            App.sounds.click();
        };
        _this.onClickBtn2 = function () {
            if (_this.props.onClickBtn2)
                _this.props.onClickBtn2();
            App.sounds.click();
        };
        _this.el = _this.DIV({ className: '&' }, [
            _this.DIV({ className: '&__closeBtn', onClick: _this.onClickCloseBtn }),
            (_this.text = _this.DIV('&__text')),
            _this.DIV({ className: 'Button2 Button2_blue', onClick: _this.onClickBtn1 }, ['Action-1']),
            _this.DIV({ className: '&__btn2 Button2 Button2_blue', onClick: _this.onClickBtn2 }, ['Action-2']),
        ]);
        return _this;
    }
    DebugScreen.prototype.show = function () {
        this.toggle(true);
    };
    DebugScreen.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.text.valueOf().innerHTML += "<div>".concat(JSON.stringify(args).replace(/,"/gm, ', "'), "</div>");
        this.counter++;
        if (this.counter > 250) {
            this.text.valueOf().innerHTML = 'clear log\n';
            this.counter = 0;
        }
    };
    DebugScreen.prototype.toggle = function (toggle) {
        this.toggleClassName('&_visible', toggle);
    };
    return DebugScreen;
}(Component));
export { DebugScreen };
